__turbopack_context__.v({
  "root": "detailed-slider-module-scss-module__Nd_Blq__root",
  "root__slider": "detailed-slider-module-scss-module__Nd_Blq__root__slider",
});
